export default __webpack_public_path__ + "static/ocean-cleanup-v2-16c0b60a0171c3a566be69ad0848ca77.jpg";